export default value => /[A-Z]/.test(value);
